module.exports = __webpack_public_path__ + "img/network-backgtound-tablet.b4335f00.png";